module.exports = __webpack_public_path__ + "static/media/SF-20-A (1).fc68583c.mp3";